export interface OnlineBookingLegalSettings {
  responsible_name: string | null;
  legal_representative: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  privacy_email: string | null;
  supervisory_authority: string | null;
  imprint_url: string | null;
  retention_note: string | null;
  third_party_note: string | null;
}

export type OnlineBookingLegalForm = {
  [K in keyof OnlineBookingLegalSettings]: string;
};

export function onlineBookingLegalFromApi(
  legal: OnlineBookingLegalSettings | null | undefined,
): OnlineBookingLegalForm {
  return {
    responsible_name: legal?.responsible_name ?? "",
    legal_representative: legal?.legal_representative ?? "",
    contact_email: legal?.contact_email ?? "",
    contact_phone: legal?.contact_phone ?? "",
    privacy_email: legal?.privacy_email ?? "",
    supervisory_authority: legal?.supervisory_authority ?? "",
    imprint_url: legal?.imprint_url ?? "",
    retention_note: legal?.retention_note ?? "",
    third_party_note: legal?.third_party_note ?? "",
  };
}

export const EMPTY_ONLINE_BOOKING_LEGAL: OnlineBookingLegalForm = {
  responsible_name: "",
  legal_representative: "",
  contact_email: "",
  contact_phone: "",
  privacy_email: "",
  supervisory_authority: "",
  imprint_url: "",
  retention_note: "",
  third_party_note: "",
};
